/* collection.js — Pique Vitality. Facets, mobile filter drawer, grid switcher, load-more.
   Progressive enhancement: everything degrades to plain links/forms without JS. */
(function () {
  'use strict';
  const root = document.querySelector('[data-collection-root]');
  if (!root) return;

  const form = root.querySelector('[data-facet-form]');

  /* ---- Facet form: auto-apply on change (debounced for price typing) ---- */
  if (form) {
    let t;
    const submit = () => form.requestSubmit ? form.requestSubmit() : form.submit();
    form.addEventListener('change', (e) => {
      // price inputs debounce; checkboxes/sort submit immediately
      if (e.target.type === 'number') { clearTimeout(t); t = setTimeout(submit, 650); }
      else submit();
    });
    // sort lives outside the form (form="FacetForm"); catch its change too
    root.querySelectorAll('[data-sort]').forEach((sel) =>
      sel.addEventListener('change', submit));
    // mobile sort is a nameless mirror — sync it to the real select, then submit
    root.querySelectorAll('[data-msort]').forEach((msel) =>
      msel.addEventListener('change', () => {
        const real = root.querySelector('[data-sort]');
        if (real) real.value = msel.value;
        submit();
      }));
  }

  /* ---- Mobile filter drawer ---- */
  const drawer = root.querySelector('[data-facet-drawer]');
  const scrim = root.querySelector('[data-facet-scrim]');
  function openDrawer() { if (!drawer) return; drawer.setAttribute('data-open', ''); if (scrim) scrim.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.removeAttribute('data-open'); if (scrim) scrim.hidden = true; document.body.style.overflow = ''; }
  root.querySelectorAll('[data-facet-open]').forEach((b) => b.addEventListener('click', openDrawer));
  root.querySelectorAll('[data-facet-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  if (scrim) scrim.addEventListener('click', closeDrawer);
  // "Show results" inside the drawer should also close it (form submits → page reload anyway)
  root.querySelectorAll('[data-facet-apply]').forEach((b) => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ---- Mobile grid switcher (1-up / 2-up) ---- */
  const toggle = root.querySelector('[data-grid-toggle]');
  const grid = root.querySelector('[data-product-grid]');
  if (toggle && grid) {
    const initial = root.getAttribute('data-cols-m') || '1';
    const setCols = (n) => {
      grid.style.setProperty('--cols-m', n);
      toggle.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b.dataset.cols === n));
    };
    toggle.querySelectorAll('button').forEach((b) =>
      b.addEventListener('click', () => setCols(b.dataset.cols)));
    setCols(initial);
  }

  /* ---- Top-bar facet pills: close others / outside-click (top-bar layout only) ---- */
  const isTopbar = root.classList.contains('coll--topbar');
  if (isTopbar) {
    root.querySelectorAll('[data-facet-pill]').forEach((pill) => {
      pill.addEventListener('toggle', () => {
        if (pill.open) root.querySelectorAll('[data-facet-pill]').forEach((p) => { if (p !== pill) p.open = false; });
      });
    });
    document.addEventListener('click', (e) => {
      // ignore clicks inside the mobile drawer (pills act as accordions there)
      if (window.matchMedia('(max-width:849px)').matches) return;
      if (!e.target.closest('[data-facet-pill]'))
        root.querySelectorAll('[data-facet-pill]').forEach((p) => (p.open = false));
    });
  }

  /* ---- Progressive "Load more" — fetch next page, append, update count ---- */
  let loadBtn = root.querySelector('[data-load-more]');
  async function loadMore(e) {
    e.preventDefault();
    const url = loadBtn.getAttribute('href');
    const label = loadBtn.textContent;
    loadBtn.textContent = (window.theme && window.theme.strings && window.theme.strings.loading) || 'Loading…';
    loadBtn.style.pointerEvents = 'none';
    try {
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-product-grid]');
      if (newGrid && grid) {
        [...newGrid.children].forEach((c) => grid.appendChild(c));
        // re-bind add-to-cart on appended cards is automatic (delegated in global.js)
      }
      // swap the whole "more" block (new count, track, next link)
      const newMore = doc.querySelector('.coll__more');
      const more = root.querySelector('.coll__more');
      if (newMore && more) {
        more.replaceWith(newMore);
        loadBtn = root.querySelector('[data-load-more]');
        if (loadBtn) loadBtn.addEventListener('click', loadMore);
      } else if (more) {
        more.querySelector('[data-load-more]')?.remove();
      }
      history.replaceState({}, '', url);
    } catch (err) {
      loadBtn.textContent = label;
      loadBtn.style.pointerEvents = '';
    }
  }
  if (loadBtn) loadBtn.addEventListener('click', loadMore);
})();
